import { Resource } from 'i18next';

export const resolveNamespaces = (resources: Resource) =>
  Array.from(new Set(Object.values(resources).map(Object.keys).flat()));
